import request from '../../utils/request'
import store from '../../store/index'

// 获取报警消息列表
export const getAlarmMessages = (info) => {
  return request({
    url: '/admin-getAlarmMessages',
    method: 'get',
    params: {
      page: store.getters.currentPage,
      page_size: store.getters.pageSize,
      scene: 'system',
      ...info
    }
  })
}
// 获取报警消息详情
export const getAlarmMessagesDetail = (info) => {
  return request({
    url: '/admin-getAlarmMessageDetail',
    method: 'get',
    params: {
      alarm_message_id: info
    }
  })
}
// 更新报警消息
export const updateAlarmMessage = (info) => {
  return request({
    url: '/admin-updateAlarmMessage',
    method: 'post',
    data: {
      ...info
    }
  })
}